import { Injectable } from '@angular/core';
import { createEffect, ofType, Actions } from '@ngrx/effects';
import { EUOMActions, GetUOM, AddUOM, EditUOM } from '../actions/uom.action';
import { map, mergeMap, catchError } from 'rxjs/operators';
import { of } from 'rxjs';
import { IAppState } from '../state/app.state';
import { Store } from '@ngrx/store';
import { UOMService } from '../../Services/UOM/uom.service';




@Injectable()
export class UOMEffects {

    getUOM$ = createEffect(() => this.actions$.pipe(
        ofType<GetUOM>(EUOMActions.GetUOM),
        map(action => action.payload),
        mergeMap((payload : any) => this.uomService.getUOM(payload)
        .pipe(map((result: any) => ({ type: '[UOM] Set UOM Details', payload: result })),
          catchError((err) => of({ type: 'Set UOM Error', payload:err, from: 'getUOM' }))
        )
      )
    ));

    addUOM$ = createEffect(() => this.actions$.pipe(
        ofType<AddUOM>(EUOMActions.AddUOM),
        map(action => action.payload),
        mergeMap((payload : any) => this.uomService.addUOM(payload)
        .pipe(map((result: any) => ({ type: 'Set UOM Success', payload: result, from: 'AddUOM' })),
          catchError((err) => of({ type: 'Set UOM Error', payload:err, from: 'AddUOM' }))
        )
      )
    ));

    editUOM$ = createEffect(() => this.actions$.pipe(
        ofType<EditUOM>(EUOMActions.EditUOM),
        map(action => action.payload),
        mergeMap((payload : any) => this.uomService.editUOM(payload)
        .pipe(map((result: any) => ({ type: '[UOM] Get Edit UOM Success', payload: result, from: 'EditUOM' })),
          catchError((err) => of({ type: '[] Get Edit UOM Error', payload:err, from: 'EditUOM' }))
        )
      )
    ));
    constructor( private actions$: Actions,
        private store: Store<IAppState>,
        private uomService: UOMService
    ){}
}
